"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EditRelationDialog = _interopRequireDefault(require("./components/EditRelationDialog.vue"));
var storeApi = _interopRequireWildcard(require("@/api/store"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditRelationDialog: _EditRelationDialog.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        skuId: '',
        mainGoodsName: '',
        subGoodsName: '',
        timeRange: []
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true
    };
  },
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    resetSearch: function resetSearch() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        skuId: '',
        mainGoodsName: '',
        subGoodsName: '',
        timeRange: []
      };
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      var params = {
        page: pram.page,
        limit: pram.limit,
        skuId: pram.skuId || undefined,
        mainGoodsName: pram.mainGoodsName || undefined,
        subGoodsName: pram.subGoodsName || undefined,
        createTimeStart: pram.timeRange && pram.timeRange[0],
        createTimeEnd: pram.timeRange && pram.timeRange[1]
      };
      storeApi.oneCardRightConfigPage(params).then(function (data) {
        _this.listData = data || {
          list: [],
          total: 0
        };
      }).catch(function () {
        _this.listData = {
          list: [],
          total: 0
        };
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    handleAddRelation: function handleAddRelation() {
      this.$refs.editRelationDialogRef && this.$refs.editRelationDialogRef.open({
        mainGoodsName: ''
      });
    },
    handleEditRelation: function handleEditRelation(row) {
      this.$refs.editRelationDialogRef && this.$refs.editRelationDialogRef.open(row.manageId);
    }
  }
};